import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function ConsultaracturaEdoCuentaPdf_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "consultarFacturaEdoCuentaPDF",
    rutaEndPoint: "/GwBrmFacturaEBS/consultarFacturaEdoCuentaPdf",
    sistemaOrigen: "AppSKY",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.BackendSF,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

export interface EBMHeaderRequest {
  Operacion: string;

  SistemaOrigen: string;
}

export function builtEBMHeaderRequest(l_Operacion: string, l_SistemaOrigen: string) {
  var retorno: EBMHeaderRequest = {
    Operacion: l_Operacion,

    SistemaOrigen: l_SistemaOrigen
  }

  return retorno;
}


//ENTRADA
export interface ConsultarFacturaEdoCuentaPDF_Entrada {
  EBMHeaderRequest: EBMHeaderRequest;
  Cuenta: Cuenta;
}

export interface Cuenta {
  Facturas: Facturas;
}

export interface Facturas {
  Factura: Factura[];
}

export interface Factura {
  NumeroFactura: string;
  FacturaFormateada: null | string;
}


export function builtConsultarFacturaEdoCuentaPDFEntrada(
  l_NumeroFactura: string,
  v_EBMHeaderRequest: EBMHeaderRequest
) {

  const arr_Facturas: Factura[] = [];

  var v_Factura: Factura = {
    NumeroFactura: l_NumeroFactura,
    FacturaFormateada: ""
  }

  arr_Facturas.push(v_Factura);

  var v_Facturas: Facturas = {
    Factura: arr_Facturas
  }

  var v_Cuenta: Cuenta = {
    Facturas: v_Facturas
  }

  var retorno: ConsultarFacturaEdoCuentaPDF_Entrada = {
    EBMHeaderRequest: v_EBMHeaderRequest,
    Cuenta: v_Cuenta

  };

  return retorno;
}


//SALIDA
export interface ConsultaracturaEdoCuentaPdf_Salida {
  Cuenta: Cuenta;
}



export type ConsultarFacturaEdoCuentaPdf_Respuesta = EncabezadoRespuestaInterna &
  ConsultaracturaEdoCuentaPdf_Salida;